import React from 'react'

const CrossFailure = () => {
    return (
        <svg
            width="62"
            height="62"
            viewBox="0 0 86 86"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="43"
                cy="43"
                r="31.875"
                fill="#F287B7"
            />

            <path
                d="M32 32L54 54"
                stroke="white"
                strokeWidth="6"
                strokeLinecap="round"
            />
            <path
                d="M54 32L32 54"
                stroke="white"
                strokeWidth="6"
                strokeLinecap="round"
            />
        </svg>
    )
}

export default CrossFailure